import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

// 개인 회원
const User = lazy(() => import('@pages/user'));
const UserList = lazy(() => import('@pages/user/user/UserList'));
const UserDetail = lazy(() => import('@pages/user/user/UserDetail'));
// 탈퇴한 회원
const WithdrawnUserList = lazy(() => import('@pages/user/withDrawnUser/WithdrawnUserList'));
const WithdrawnUserDetail = lazy(() => import('@pages/user/withDrawnUser/WithdrawnUserDetail'));
const UserEmailList = lazy(() => import('@pages/user/email/UserEmailList'));

export const userRoutes: TypedRouteObject = {
	path: ROOTS.USER,
	element: withSuspense(User),
	handle: {
		title: '회원 관리',
		subTitle: '락앤런 트레일러닝 회원가입 현황'
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 회원 목록
		{
			path: paths.user.list.path,
			element: withSuspense(UserList),
			handle: {
				title: '락앤런 트레일러닝 회원 관리',
				subTitle: '회원 전체 목록'
			}
		},
		{
			path: paths.user.detail.path,
			element: withSuspense(UserDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 회원 관리',
				subTitle: '회원 관리 > 개인 회원 전체 목록 > 회원 상세 정보'
			}
		},
		// 탈퇴한 회원 목록
		{
			path: paths.user.withdrawnUser.list.path,
			element: withSuspense(WithdrawnUserList),
			handle: {
				title: '락앤런 트레일러닝 탈퇴한 회원 목록',
				subTitle: '탈퇴한 회원 전체 목록'
			}
		},
		{
			path: paths.user.withdrawnUser.detail.path,
			element: withSuspense(WithdrawnUserDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 탈퇴 회원 ',
				subTitle: '회원 관리 > 탈퇴 회원 전체 목록 > 회원 상세 정보'
			}
		},
		// 발송 이메일 리스트
		{
			path: paths.user.email.list.path,
			element: withSuspense(UserEmailList),
			handle: {
				title: '락앤런 이메일 발송 관리',
				subTitle: '락앤런 회원 이메일 발송 목록'
			}
		}
	]
}
